import {
  getStaticPaths,
  getStaticProps,
  ShowroomPage,
} from '@public/CmsPage/ShowroomPage'

export { getStaticProps, getStaticPaths }

export default ShowroomPage
